import React, { FC, Fragment } from 'react';
import { Box, FormGroup, FormControlLabel, Checkbox, Typography, Chip } from '@mui/material';
import { EventOrgTypeFilter, OrderEventFilters } from 'models/order-event';
import { useTranslation } from 'react-i18next';

type OrderTimelineFiltersProps = {
    onFilterChange: (event: OrderEventFilters, orgType: EventOrgTypeFilter) => void;
};
const OrderTimelineFilters: FC<OrderTimelineFiltersProps> = ({ onFilterChange }: OrderTimelineFiltersProps) => {
    const { t: translate } = useTranslation(['order-event', 'common']);
    const [eventCheckboxes, setEventCheckboxes] = React.useState<OrderEventFilters>({
        files: true,
        modified: true,
        comments: true,
        chat: true,
        status: true,
    });
    const { files, comments, chat, modified, status } = eventCheckboxes;

    const [orgTypeCheckboxes, setOrgTypeCheckboxes] = React.useState<EventOrgTypeFilter>({
        showClinicEvents: true,
        showLabEvents: true,
    });
    const { showClinicEvents, showLabEvents } = orgTypeCheckboxes;

    const handleEventCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newState = { ...eventCheckboxes, [event.target.name]: event.target.checked };
        setEventCheckboxes(newState);
        onFilterChange(newState, orgTypeCheckboxes);
    };

    const handleOrgCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newState = { ...orgTypeCheckboxes, [event.target.name]: event.target.checked };
        setOrgTypeCheckboxes(newState);
        onFilterChange(eventCheckboxes, newState);
    };

    return (
        <Fragment>
            <Box>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="secondary"
                                name="comments"
                                checked={comments}
                                onChange={handleEventCheckboxChange}
                            />
                        }
                        label={translate('SHOW_COMMENTS')}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="secondary"
                                name="chat"
                                checked={chat}
                                onChange={handleEventCheckboxChange}
                            />
                        }
                        label={translate('SHOW_CHAT')}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="secondary"
                                name="files"
                                checked={files}
                                onChange={handleEventCheckboxChange}
                            />
                        }
                        label={translate('SHOW_ADDED_FILES')}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="secondary"
                                name="modified"
                                checked={modified}
                                onChange={handleEventCheckboxChange}
                            />
                        }
                        label={translate('SHOW_ORDER_MODIFIED')}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="secondary"
                                name="status"
                                checked={status}
                                onChange={handleEventCheckboxChange}
                            />
                        }
                        label={translate('SHOW_STATUS_CHANGES')}
                    />
                </FormGroup>
            </Box>
            <Box mt={2}>
                <Typography variant="h3">{translate('EVENTS')}</Typography>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="secondary"
                                name="showClinicEvents"
                                checked={showClinicEvents}
                                onChange={handleOrgCheckboxChange}
                            />
                        }
                        label={
                            <Chip
                                sx={{ backgroundColor: '#9e2b64', color: '#fff' }}
                                label={translate('common:CLINIC')}
                            />
                        }
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="secondary"
                                name="showLabEvents"
                                checked={showLabEvents}
                                onChange={handleOrgCheckboxChange}
                            />
                        }
                        label={
                            <Chip sx={{ backgroundColor: '#1f870c', color: '#fff' }} label={translate('common:LAB')} />
                        }
                    />
                </FormGroup>
            </Box>
        </Fragment>
    );
};

export default OrderTimelineFilters;
